import IconButton from './IconButton';

// export types
export type { IconButtonProps } from './IconButton';

// export components
export { IconButton };
export default IconButton;
